import React, { useContext, useEffect, useRef, useState, useCallback } from 'react';
import { useParams } from 'umi';
import Permission from '@/pages/dashboard/components/NoPermission';
import Loading from '@/pages/dashboard/components/Loadings';
import { IframeUrl } from '@/pages/home/components/IframeUrl';
import { LayoutContext } from '@/pages/benchmark/state/LayoutContext';
import { BENCHMARK_GAME_CODE } from '@/pages/benchmark/_config/constant';
import {
  checkReportIdWithName,
  getDashboardType,
} from '@/pages/dashboard/utils/utils';
import { PAGE_TYPE_AUTH_PATH } from '@/pages/dashboard/_config/constant';
import { getAuthToken } from '@/pages/benchmark/services/benchmark';

interface ReportInfoType {
  loading: boolean;
  error: string;
  authUrl: string;
}

const INIT_REPORT_INFO: ReportInfoType = {
  loading: false,
  error: '',
  authUrl: '',
};

export default () => {
  const [reportInfo, setReportInfo] = useState<ReportInfoType>(INIT_REPORT_INFO);
  const menuRef = useRef<any>(null);
  const { reportId } = useParams() as any;
  const {currentMenu } = useContext(LayoutContext);

  const setState = useCallback((params: Partial<ReportInfoType> = {}) => {
    setReportInfo({
      ...INIT_REPORT_INFO,
      ...params,
    });
  }, []);

  const openAuthReport = useCallback(async () => {
    if (!reportId) {
      setState({ error: '未获取到报表信息' });
      return;
    }

    if (
      !currentMenu ||
      getDashboardType(currentMenu) !== PAGE_TYPE_AUTH_PATH ||
      !checkReportIdWithName(reportId, currentMenu?.name_en)
    ) {
      setState({ error: '未匹配到AuthPath菜单' });
      return;
    }

    const { auth_path: authPathRaw,id = '', u_id: uId = '', page_type: pageType = PAGE_TYPE_AUTH_PATH } = currentMenu as any;
    const authPath = `${authPathRaw || ''}`.trim();

    if (!authPath) {
      setState({ error: '未获取到报表URL' });
      return;
    }

    setState({ loading: true });
    menuRef.current = currentMenu;

    try {
      const result = await getAuthToken({
        res_id: 'benchmark',
        game_code: BENCHMARK_GAME_CODE,
        menu_id: uId,
        page_type: pageType,
        page_value: authPath,
      });

      if (menuRef.current?.id !== currentMenu?.id) return;

      const token = result?.data?.token;
      if (!token) {
        setState({ error: '获取鉴权token失败' });
        return;
      }

      const connector = authPath.includes('?') ? '&' : '?';
      const proxyUrl = `${authPath}${connector}token=${encodeURIComponent(token)}`;

      setState({ authUrl: proxyUrl });

    } catch (err) {
      if (menuRef.current?.id !== currentMenu?.id) return;
      setState({ error: '获取鉴权信息失败' });
    }
  }, [reportId, currentMenu, setState]);

  useEffect(() => {
    openAuthReport();
  }, [openAuthReport]);

  if (reportInfo.loading) {
    return <Loading />;
  }

  if (reportInfo.error) {
    return <Permission type="error" textCN={reportInfo.error} />;
  }

  return (
    <>
      <IframeUrl url={reportInfo.authUrl} />
    </>
  );
};